var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "create-template-domain-modal",
        title: _vm.$t("label.domain_template_add"),
        scrollable: "",
        "hide-footer": "",
      },
    },
    [
      _c(
        "b-form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.onSubmit.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "b-form-group",
            {
              attrs: {
                label: _vm.$t("label.domain_name"),
                "label-for": "domain-name-input",
              },
            },
            [
              _c("b-form-input", {
                attrs: {
                  id: "domain-name-input",
                  type: "text",
                  disabled: _vm.loading,
                  placeholder: _vm.$t("label.domain_template_add_placeholder"),
                  required: "",
                },
                model: {
                  value: _vm.name,
                  callback: function ($$v) {
                    _vm.name = $$v
                  },
                  expression: "name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "text-center" },
            [
              _c(
                "b-button",
                {
                  attrs: {
                    type: "submit",
                    variant: "primary",
                    disabled: _vm.loading || _vm.patgames.length === 0,
                  },
                },
                [_vm._v(_vm._s(_vm.$t("btn.new")))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-alert",
            {
              staticStyle: { "margin-top": "1rem" },
              attrs: { show: _vm.error !== null, variant: "danger" },
            },
            [_vm._v("\n      " + _vm._s(_vm.error) + "\n    ")]
          ),
          _vm._v(" "),
          _c("div", [
            _vm._v(
              "Voici les domaines d'activités qui seront lié à ce template:"
            ),
          ]),
          _vm._v(" "),
          _c("b-table", {
            attrs: { fields: _vm.fields, items: _vm.activeDomains },
            scopedSlots: _vm._u([
              {
                key: "cell(patgames)",
                fn: function (row) {
                  return [
                    _c("b-form-select", {
                      attrs: {
                        options: _vm.unlinkedPatgames,
                        "value-field": "act_id",
                        "text-field": "act_label",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.updatePatgamesDomain($event, row.item)
                        },
                      },
                      scopedSlots: _vm._u(
                        [
                          _vm.unlinkedPatgames.length !== 0
                            ? {
                                key: "first",
                                fn: function () {
                                  return [
                                    _c(
                                      "b-form-select-option",
                                      { attrs: { value: -42 } },
                                      [_vm._v("Ajouter tous")]
                                    ),
                                  ]
                                },
                                proxy: true,
                              }
                            : null,
                        ],
                        null,
                        true
                      ),
                    }),
                    _vm._v(" "),
                    _vm._l(
                      _vm.patgames.filter(
                        (m) => m.act_dac_id === row.item.dac_id
                      ),
                      function (module) {
                        return _c(
                          "b-button",
                          {
                            key: "module-" + module.act_id,
                            staticStyle: { margin: "1px" },
                            attrs: { size: "sm" },
                            on: {
                              click: function ($event) {
                                return _vm.removeModuleFromDomain(module)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(module.act_label) +
                                "\n        "
                            ),
                          ]
                        )
                      }
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }